import styled from 'styled-components';
import { theme } from '../../../styles/theme';

export const Container = styled.nav<{ $scrolled: boolean }>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: 200;
  background: rgba(255, 255, 255, 0.96);
  backdrop-filter: blur(12px);
  border-bottom: 1px solid ${theme.colors.border};
  padding: 0 8%;
  height: 68px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  transition: box-shadow 0.3s;
  box-shadow: ${(p) => (p.$scrolled ? '0 2px 24px rgba(0,0,0,0.08)' : 'none')};
`;

export const Logo = styled.a`
  display: flex;
  align-items: center;
  text-decoration: none;

  img {
    height: 32px;
    width: auto;
  }
`;

export const NavLinks = styled.div`
  display: flex;
  gap: 2rem;
  align-items: center;
`;

export const NavLink = styled.a`
  color: ${theme.colors.mid};
  font-size: 0.9rem;
  font-weight: 500;
  transition: color 0.2s;

  &:hover {
    color: ${theme.colors.blue};
  }
`;

export const DownloadButton = styled.a`
  background: ${theme.colors.black} !important;
  color: ${theme.colors.white} !important;
  padding: 0.55rem 1.4rem;
  border-radius: 8px;
  font-weight: 600 !important;
  font-size: 0.88rem !important;
  transition: background 0.2s, transform 0.2s !important;

  &:hover {
    background: ${theme.colors.orange} !important;
    color: ${theme.colors.white} !important;
    transform: translateY(-1px);
  }
`;
